import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { FaUserCheck, FaUserEdit, FaExclamationTriangle, FaRegTimesCircle, FaRegCheckCircle } from "react-icons/fa";
import { jwtDecode } from 'jwt-decode';
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { useNavigate } from "react-router-dom";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Tooltip from "@mui/material/Tooltip";
import { MdOutlineDoneAll, MdClose } from "react-icons/md";
import { API_URL } from "../../config";
import { useToast } from "../../components/ui/ToastContext";
import DatePicker from "../../components/Datapicker";
import { GrValidate } from "react-icons/gr";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { Checkbox } from "@mui/material";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();
dayjs.extend(timezone);

function DashboardCard24viwe() {
  const location = useLocation();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const { item: initialData } = location.state || {};

  useEffect(() => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      entityId: initialData?.planning_id,
      description: `A deschis formularul de vizualizare planificare (ID: ${initialData?.planning_id || ''})`,
    });
  }, []);
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [plandataday, setplanDataday] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const [selecteddeleteuser3, setSelecteddeleteuser3] = useState(null);
  const [selecteddeleteuser4, setSelecteddeleteuser4] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedInstitutionId1, setSelectedInstitutionId1] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [Data2, setData2] = useState([]);
  const [Data3, setData3] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [dateFilter, setDateFilter] = useState({
    from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD')
  });

  const token = localStorage.getItem('jwtToken');

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowGrid(false);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.userId]);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/planning/details`, {
        planning_id: selectedEditRowData?.planning_id
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const structuredData = response.data.data;

      if (structuredData.length > 0) {
        const planning = structuredData[0].plannings[0];
        const dayList = planning.days;
        setStartDate(planning.start_date);
        setEndDate(planning.end_date);
        setplanDataday(dayList);
        setIsActive(planning.is_validated);
        const details = dayList.flatMap(day => day.details);
        setSelectedInstitutionId1(planning.days[0])
        setData2(details.filter(i => i.activity_type_id !== 2));
        setData3(details.filter(i => i.activity_type_id === 2 && i.other_activity_detail_id !== null));
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    if (selectedEditRowData && selectedEditRowData.planning_id) {
      fetchData();
    }
  }, [selectedEditRowData]);

  useEffect(() => {
    if (selecteddeleteuser3) {
      editreport(selecteddeleteuser3);
    }
  }, [selecteddeleteuser3]);

  useEffect(() => {
    if (selecteddeleteuser4) {
      editotherreport(selecteddeleteuser4);
    }
  }, [selecteddeleteuser4]);

  useEffect(() => {
    if (selecteddeleteuser) {
      createreport(selecteddeleteuser);
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      createotherreport(selecteddeleteuser1);
    }
  }, [selecteddeleteuser1]);

  const createreport = async (item) => {
    navigate("/planning/reportplanning", { state: { item } });
  };

  const createotherreport = async (item) => {
    navigate("/planning/reportotherplanning", { state: { item } });
  };

  const editreport = async (item) => {
    navigate("/reporting/viwereporting", { state: { item } });
  };

  const editotherreport = async (item) => {
    navigate("/otheractivity/viweotheractivity", { state: { item } });
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const generateDatesInRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = dayjs(startDate);

    while (currentDate.isBefore(dayjs(endDate).add(1, 'day'))) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate = currentDate.add(1, 'day');
    }
    return dates;
  };

  const getDatesWithData = (dates, data) => {
    let newId = 0;

    return dates.map(date => {
      const item = data.find(item =>
        item.date && dayjs(item.date).isValid() &&
        dayjs(item.date).isSame(dayjs(date), 'day')
      );

      if (item) {
        return item;
      } else {
        return {
          date,
          planning_day_id: newId++,
          total: "Fără vizite"
        };
      }
    });
  };

  const datesInRange = generateDatesInRange(startDate, endDate);
  const datesWithData = getDatesWithData(datesInRange, plandataday);

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(datesWithData.length / itemsPerPage);
  const currentItems = datesWithData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).length / itemsPerPage);
  const currentItems1 = Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).slice(
    (currentPage1 - 1) * itemsPerPage,
    currentPage1 * itemsPerPage
  );

  const handleClick = () => {
    showToast({
      message: (
        <div>
          <p>{isActive ? 'Sigur doriți să devalidati această înregistrare?' : 'Sigur doriți să validati această înregistrare?'}</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete1();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat() }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  }

  const confirmDelete1 = async () => {
    try {
      await axios.put(
        `${API_URL}/api/validateplanning`,
        {
          planning_id: selectedEditRowData.planning_id,
          is_validated: !isActive,
          submited_user_id: user?.userId
        }
      );
      setIsActive(!isActive)
      showToast({
        message: "Datele au fost validate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la ștergerea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const anulat = async () => {
    showToast({
      message: "Anulat",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      duration: 20
    });
  };

  const closeModal = () => {
    setIsOpen(false);
  }

  const openModal = async (rowData) => {
    try {
      let doctorName = "-";
      let institution = "-";

      if (rowData.obiect_type_id === 1) {
        doctorName = rowData.physician?.name || "-";
      } else {
        institution = rowData.location?.institution || "-";
      }

      const usersResponse = await axios.get(`${API_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const currentUser = usersResponse.data.find((item) => item.user_id === user.userId);
      const userName = currentUser?.user_name_surname || '';
      const historyResponse = await axios.get(`${API_URL}/api/historydoc`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          user_name_surname: userName,
          doctor: doctorName === "-" ? null : doctorName,
          institutie: institution === "-" ? null : institution
        },
      });

      setSelectedRow(historyResponse.data);
      setIsOpen(true);
    } catch (error) {
      console.error("Error opening modal:", error);
      setSelectedRow([]);
      setIsOpen(true);
    }
  };

  const sortedData = [...selectedRow].sort((a, b) => {
    const dateA = dayjs(a.date, "DD-MM-YYYY");
    const dateB = dayjs(b.date, "DD-MM-YYYY");

    if (sortConfig.direction === 'asc') {
      return dateA.isBefore(dateB) ? -1 : 1;
    } else {
      return dateA.isAfter(dateB) ? -1 : 1;
    }
  });

  const filteredData = sortedData.filter(item => {
    const itemDate = dayjs(item.date, "DD-MM-YYYY");
    return itemDate.isAfter(dayjs(dateFilter.from)) &&
      itemDate.isBefore(dayjs(dateFilter.to).add(1, 'day'));
  });

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const isSpecialitateaEmpty = filteredData.every(item =>
    !item.specialitatea || item.specialitatea.trim() === ''
  );

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
              <CardHeader subheader="Informatia nu poate fii modificata"
                title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                action={
                  user && user.role !== 'User' && (
                    <Tooltip title="Validare" arrow placement="top">
                      <button
                        className={`px-4 py-2 rounded-md text-sm font-semibold ${isActive === true
                          ? "bg-green-700 text-white"
                          : "bg-red-500 text-white"
                          }`}
                        onClick={handleClick}
                      >
                        {isActive === true ? <GrValidate size={20} /> : <GrValidate size={20} />}
                      </button>
                    </Tooltip>
                  )}
              />
              <Divider className="dark:bg-gray-400" />
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="md:grid md:grid-cols-1 sm:grid-cols-2 md:gap-6 lg:flex lg:gap-2">
                    <div className="relative w-full mt-3">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                        Perioada: De la..
                      </label>
                      <DatePicker
                        selectedDate={startDate}
                        handleDateChange={handleStartDateChange}
                        disabled={true}
                      />
                    </div>
                    <div className="relative w-full mt-3">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                        Perioada: Pana la..
                      </label>
                      <DatePicker
                        selectedDate={endDate}
                        handleDateChange={handleEndDateChange}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="relative mt-4">
                  <Divider className="dark:bg-gray-400" />
                  <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
                    <div className="relative">
                      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Planificare detalii</h2>
                    </div>
                  </header>

                  <div className="p-3" >
                    <div className="lg:flex lg:gap-4">
                      <div className="lg:w-1/5">
                        <table className="overflow-x-auto w-full">
                          <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                            <tr>
                              <th className="p-2">
                                <div className="font-semibold text-left">Data</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Numarul de vizite</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.map((item, idx) => (
                              <tr
                                role="button"
                                key={idx}
                                className={` ${item === selectedInstitutionId1 ? 'bg-violet-300 dark:bg-violet-200' : ''}  ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedInstitutionId1(item);
                                }}
                              >
                                <td className="p-2 whitespace-nowrap">
                                  <div className="text-left">{dayjs(item.date, "DD-MM-YYYY", true).format("DD-MM-YYYY")}</div>
                                </td>
                                <td className="p-2 whitespace-nowrap">
                                  <div className="text-center">
                                    {
                                      Data2.filter((i) => i.planning_day_id === item.planning_day_id).length + Data3.filter((i) => i.planning_day_id === item.planning_day_id).length
                                    }
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {plandataday.length > 5 && (
                          <div className="flex justify-center mt-4 ">
                            <button
                              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                              disabled={currentPage === 1}
                            >
                              Prev
                            </button>

                            {currentPage > 3 && (
                              <>
                                <button
                                  onClick={() => setCurrentPage(1)}
                                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                >
                                  1
                                </button>
                                <span className="px-2">...</span>
                              </>
                            )}

                            {Array.from({ length: totalPages }, (_, index) => {
                              const page = index + 1;

                              if (
                                page === currentPage ||
                                (page >= currentPage - 1 && page <= currentPage + 1)
                              ) {
                                return (
                                  <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`px-4 py-2 text-sm font-medium ${currentPage === page
                                      ? "bg-gray-500 text-white"
                                      : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      }`}
                                  >
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {currentPage < totalPages - 2 && (
                              <>
                                <span className="px-2">...</span>
                                <button
                                  onClick={() => setCurrentPage(totalPages)}
                                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                >
                                  {totalPages}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() =>
                                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                              }
                              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="lg:w-4/5 lg:mt-0 mt-4">
                        {selectedInstitutionId1 != null ? (<>
                          {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id && i.obiect_type_id != null).length != 0 || Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length != 0 ? (
                            <>
                              <div className="overflow-x-auto max-xs:sr-only">
                                {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id && i.obiect_type_id != null).length > 0 ? (
                                  <>
                                    <h2 className="font-semibold text-gray-700 dark:text-gray-200">Vizite</h2>
                                    <table className="table-auto w-full max-xs:sr-only">
                                      <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                        <tr>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Doctor</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Specialitatea</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Tip</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Institutia</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Adresa</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Oras</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Vizita Dubla</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Actiune</div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentItems1.map((item, idx) => (
                                          <tr
                                            key={idx}
                                            className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 
                                          ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}
                                            onClick={() => openModal(item)}
                                            role="button"
                                          >
                                            <td className="p-2 whitespace-nowrap"
                                              onClick={() => openModal(item)}>
                                              <div className="text-left">
                                                {item.obiect_type_id === 1 ? (
                                                  <div className="flex items-center gap-1.5">
                                                    <span>{item.physician?.name || item.physician}</span>
                                                    {(item.physician?.data_acord || item.data_acord) ? (
                                                      <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                        <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                        </svg>
                                                      </span>
                                                    ) : null}
                                                  </div>
                                                ) : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 whitespace-nowrap"
                                              onClick={() => openModal(item)}>
                                              <div className="text-left">
                                                {item.obiect_type_id === 1 ?
                                                  item.physician?.speciality
                                                  : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.inst_type || "Nu exista institutie"}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.institution}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.address}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.city}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                <Checkbox
                                                  disabled={true}
                                                  checked={item.is_double_visit || false}
                                                  sx={{
                                                    color: item.is_double_visit ? "#10b981" : "#9ca3af",
                                                    '&.Mui-checked': {
                                                      color: "#10b981",
                                                    },
                                                    '&:hover': {
                                                      backgroundColor: "rgba(16, 185, 129, 0.1)",
                                                    },
                                                    padding: "4px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div
                                                className="font-semibold text-center"
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "20px",
                                                }}
                                              >

                                                {item.report_detail_id !== null
                                                  ? (
                                                    <div className="flex items-center space-x-2">
                                                      <Tooltip title={"Raportat"} arrow placement="top">
                                                        <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                      </Tooltip>
                                                      <Tooltip title={"Vizualizeaza"} arrow placement="top">
                                                        <IconButton
                                                          onClick={() => setSelecteddeleteuser3(item)}
                                                          color="primary"
                                                          sx={{
                                                            fontSize: "16px",
                                                            borderRadius: "50%",
                                                            "&:hover": {
                                                              backgroundColor: `#a4adad`,
                                                            },
                                                          }}
                                                        >
                                                          <FaUserEdit className="dark:text-gray-100" />
                                                        </IconButton>
                                                      </Tooltip>

                                                    </div>
                                                  ) : (
                                                    <div className="flex items-center space-x-2">
                                                      <Tooltip title={"Neraportat"} arrow placement="top">
                                                        <MdClose className="text-red-700 text-xl" />
                                                      </Tooltip>

                                                      <Tooltip title="Raporteaza" arrow placement="top">
                                                        <IconButton
                                                          onClick={() => setSelecteddeleteuser(item)}
                                                          color="primary"
                                                          sx={{
                                                            fontSize: "16px",
                                                            borderRadius: "50%",
                                                            "&:hover": {
                                                              backgroundColor: "#a4adad",
                                                            },
                                                          }}
                                                        >
                                                          <FaUserCheck className="dark:text-gray-100" />
                                                        </IconButton>
                                                      </Tooltip>
                                                    </div>
                                                  )}
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>

                                    <Transition appear show={isOpen} as={Fragment}>
                                      <Dialog as="div" className="relative z-10" onClose={closeModal}>
                                        <Transition.Child
                                          as={Fragment}
                                          enter="ease-out duration-300"
                                          enterFrom="opacity-0"
                                          enterTo="opacity-100"
                                          leave="ease-in duration-200"
                                          leaveFrom="opacity-100"
                                          leaveTo="opacity-0"
                                        >
                                          <div className="fixed inset-0 bg-black bg-opacity-25" />
                                        </Transition.Child>

                                        <div className="fixed inset-0 overflow-y-auto">
                                          <div className="flex min-h-full items-center justify-center p-4 text-center">
                                            <Transition.Child
                                              as={Fragment}
                                              enter="ease-out duration-300"
                                              enterFrom="opacity-0 scale-95"
                                              enterTo="opacity-100 scale-100"
                                              leave="ease-in duration-200"
                                              leaveFrom="opacity-100 scale-100"
                                              leaveTo="opacity-0 scale-95"
                                            >
                                              <Dialog.Panel className="w-full max-w-lg transform overflow-x-auto rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                                                <Dialog.Title
                                                  as="h3"
                                                  className="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                                                >{selectedRow[0]?.doctor ? 'Istoric Doctor: ' + selectedRow[0]?.doctor : 'Istoric Farmacie: ' + selectedRow[0]?.institutie}

                                                </Dialog.Title>
                                                <div className="mt-2">

                                                  <div className="flex flex-wrap gap-2 items-center">
                                                    <div className="flex flex-row gap-2 xs:flex-wrap">
                                                      <div className="relative w-1/2 mt-3 xs:w-full">
                                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                          Perioada: De la..
                                                        </label>
                                                        <DatePicker
                                                          selectedDate={dateFilter.from}
                                                          handleDateChange={(e) => setDateFilter({ ...dateFilter, from: e.target.value })}
                                                        />
                                                      </div>
                                                      <div className="relative w-1/2 mt-3 xs:w-full">
                                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                          Perioada: Pana la..
                                                        </label>
                                                        <DatePicker
                                                          selectedDate={dateFilter.to}
                                                          handleDateChange={(e) => setDateFilter({ ...dateFilter, to: e.target.value })}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="flex items-end h-full">
                                                      <button
                                                        onClick={() => setDateFilter({
                                                          from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                                                          to: dayjs().format('YYYY-MM-DD')
                                                        })}
                                                        className="mb-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
                                                      >
                                                        Resetează
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div className="relative h-[50vh] overflow-hidden">
                                                    <div className="absolute inset-0 overflow-y-auto">
                                                      <table className="table-auto w-full //max-xs:sr-only">
                                                        <thead className="sticky top-0 z-10 text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                                          <tr>
                                                            <th className="p-2 whitespace-nowrap">
                                                              <div
                                                                className="font-semibold text-left cursor-pointer flex items-center "
                                                                onClick={() => requestSort('date')}
                                                              >
                                                                Data
                                                                {sortConfig.key === 'date' && (
                                                                  <span className="ml-1">
                                                                    {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                  </span>
                                                                )}
                                                              </div>
                                                            </th>
                                                            {!isSpecialitateaEmpty && (
                                                              <th className="p-2">
                                                                <div className="font-semibold text-left">Specialitatea</div>
                                                              </th>
                                                            )}

                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Institutia</div>
                                                            </th>
                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Adresa</div>
                                                            </th>
                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Oras</div>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {filteredData?.map((item, idx) => (
                                                            <tr
                                                              key={idx}
                                                              className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}
                                                              onClick={() => openModal(item)}

                                                            >
                                                              <td className="p-2 whitespace-nowrap">
                                                                <div className="text-left font-bold">
                                                                  {dayjs(item.date, "DD-MM-YYYY", true).format("DD-MM-YYYY")}
                                                                </div>
                                                              </td>
                                                              <td className={item.specialitatea === null ? 'hidden' : 'p-2'}>
                                                                <div className="text-left">
                                                                  {item.specialitatea}
                                                                </div>
                                                              </td>
                                                              <td className="p-2">
                                                                <div className="text-left">
                                                                  {item.institutie}
                                                                </div>
                                                              </td>
                                                              <td className="p-2">
                                                                <div className="text-left">
                                                                  {item.adresa}
                                                                </div>
                                                              </td>
                                                              <td className="p-2">
                                                                <div className="text-left">
                                                                  {item.oras_sat}
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          ))}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="mt-4">
                                                  <button
                                                    type="button"
                                                    className="px-4 py-2 rounded bg-gray-800 text-gray-100 hover:bg-gray-500 dark:bg-gray-100 dark:text-gray-800"
                                                    onClick={closeModal}
                                                  >
                                                    Inchide
                                                  </button>
                                                </div>
                                              </Dialog.Panel>
                                            </Transition.Child>
                                          </div>
                                        </div>
                                      </Dialog>
                                    </Transition>
                                  </>
                                ) : ("")}
                              </div>

                              {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 5 && (
                                <div className="flex justify-center mt-4 max-xs:sr-only">
                                  <button
                                    onClick={() => setCurrentPage1((prev) => Math.max(prev - 1, 1))}
                                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                                    disabled={currentPage1 === 1}
                                  >
                                    Prev
                                  </button>

                                  {currentPage1 > 3 && (
                                    <>
                                      <button
                                        onClick={() => setCurrentPage1(1)}
                                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      >
                                        1
                                      </button>
                                      <span className="px-2">...</span>
                                    </>
                                  )}

                                  {Array.from({ length: totalPages1 }, (_, index) => {
                                    const page = index + 1;

                                    if (
                                      page === currentPage1 ||
                                      (page >= currentPage1 - 1 && page <= currentPage1 + 1)
                                    ) {
                                      return (
                                        <button
                                          key={page}
                                          onClick={() => setCurrentPage1(page)}
                                          className={`px-4 py-2 text-sm font-medium ${currentPage1 === page
                                            ? "bg-gray-500 text-white"
                                            : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                            }`}
                                        >
                                          {page}
                                        </button>
                                      );
                                    }
                                    return null;
                                  })}

                                  {currentPage1 < totalPages1 - 2 && (
                                    <>
                                      <span className="px-2">...</span>
                                      <button
                                        onClick={() => setCurrentPage1(totalPages1)}
                                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      >
                                        {totalPages1}
                                      </button>
                                    </>
                                  )}

                                  <button
                                    onClick={() =>
                                      setCurrentPage1((prev) => Math.min(prev + 1, totalPages1))
                                    }
                                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                                    disabled={currentPage1 === totalPages1}
                                  >
                                    Next
                                  </button>
                                </div>
                              )}

                              <div className="overflow-x-auto mt-4 max-xs:sr-only">
                                <h2 className="font-semibold text-gray-700 dark:text-gray-200">{Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 0 ? "Alte activitati" : ""}</h2>
                                {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 0 ? (
                                  <table className="w-full">
                                    <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                      <tr>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Activitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Interval ora</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Tip</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Institutia</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Specialitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Numar. pers.</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Comentariu</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Actiune</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, idx) => {
                                        return (
                                          <React.Fragment key={idx}>
                                            <tr key={idx} className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                              <td className="p-2 whitespace-normal">
                                                {item.activity_type}
                                              </td>
                                              <td className="p-2 whitespace-normal">
                                                {
                                                  item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                    ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                      <span>{item.start_time} - {item.end_time}</span>)
                                                }
                                              </td>
                                              <td className="p-2 ">
                                                {item.location?.inst_type || "Nu exista institutie"}
                                              </td>
                                              <td className="p-2">
                                                {
                                                  item.location?.institution ? (item.location?.institution + " - " + item.location?.address + " - " + item.location?.city) : "Nu exista institutie"
                                                }
                                              </td>
                                              <td className="p-2 //whitespace-nowrap">
                                                {item.activity?.speciality || "Nu exista specialitate"}
                                              </td>
                                              <td className="p-2 whitespace-nowrap">{item.persons}</td>
                                              <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow(openRow === item.index ? null : item.index)}>Afiseaza</td>
                                              <td>
                                                <div
                                                  className="font-semibold text-center"
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  {item.report_detail_id !== null
                                                    ? (
                                                      <div className="flex items-center space-x-2">
                                                        <Tooltip title={"Raportat"} arrow placement="top">
                                                          <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                        </Tooltip>
                                                        <Tooltip title={"Vizualizeaza"} arrow placement="top">
                                                          <IconButton
                                                            onClick={() => setSelecteddeleteuser4(item)}
                                                            color="primary"
                                                            sx={{
                                                              fontSize: "16px",
                                                              borderRadius: "50%",
                                                              "&:hover": {
                                                                backgroundColor: `#a4adad`,
                                                              },
                                                            }}
                                                          >
                                                            <FaUserEdit className="dark:text-gray-100" />
                                                          </IconButton>
                                                        </Tooltip>
                                                      </div>
                                                    ) : (
                                                      <div className="flex items-center space-x-2">
                                                        <Tooltip title={"Neraportat"} arrow placement="top">
                                                          <MdClose className="text-red-700 text-xl" />
                                                        </Tooltip>

                                                        <Tooltip title="Raporteaza" arrow placement="top">
                                                          <IconButton
                                                            onClick={() => setSelecteddeleteuser1(item)}
                                                            color="primary"
                                                            sx={{
                                                              fontSize: "16px",
                                                              borderRadius: "50%",
                                                              "&:hover": {
                                                                backgroundColor: "#a4adad",
                                                              },
                                                            }}
                                                          >
                                                            <FaUserCheck className="dark:text-gray-100" />
                                                          </IconButton>
                                                        </Tooltip>
                                                      </div>

                                                    )}
                                                </div>
                                              </td>
                                            </tr>
                                            {openRow === item.index && (
                                              <tr className="bg-gray-50 dark:bg-gray-800">
                                                <td colSpan="11" className="p-4">
                                                  <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                                    <div className="flex gap-1">
                                                      <strong>Comentariu:</strong>
                                                      <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>{item.comment || "Niciun comentariu"}</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                ) : ("")}
                              </div>
                            </>
                          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nu exista date in tabel.</h2>)}
                        </>
                        ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Selectati ziua din tabelul de alaturi pentru a continua.</h2>)}
                      </div>

                      <>
                        <h2 className="font-semibold text-gray-700 dark:text-gray-200 xs:hidden">Vizite </h2>

                        <table className="w-full">
                          <tbody>
                            {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, idx) => {
                              return (
                                <React.Fragment key={idx}>
                                  <tr>
                                    <td>
                                      <button
                                        className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700 w-full text-left hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onClick={() => item.report_detail_id !== null ? setSelecteddeleteuser3(item) : setSelecteddeleteuser(item)}
                                      >
                                        <div className="grid grid-cols-1 gap-2">
                                          <div className="flex items-center gap-2 p-2">
                                            <div>
                                              <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                                {item.obiect_type_id === 1 ? (
                                                  <>
                                                    <span>{item.physician?.name || item.physician}</span>
                                                    {(item.physician?.data_acord || item.data_acord) ? (
                                                      <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                        <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                        </svg>
                                                      </span>
                                                    ) : null}
                                                  </>
                                                ) : (
                                                  item.location?.institution
                                                )}
                                              </h3>
                                              <div className="text-md text-gray-500 dark:text-gray-400">
                                                {item.location?.inst_type || "Nu exista institutie"}
                                              </div>

                                              <div className="text-md text-gray-500 dark:text-gray-400">
                                                {item.obiect_type_id === 1 ?
                                                  item.physician?.speciality + " - " + item.location?.institution
                                                  : null}
                                              </div>

                                              <div className="text-md text-gray-500 dark:text-gray-400">
                                                {item.location?.address + " - " + item.location?.city}
                                              </div>
                                            </div>
                                          </div>

                                          <div className="flex justify-end items-center">
                                            <div className="flex gap-1">
                                              {item.report_detail_id !== null ? (
                                                <div className="flex items-center space-x-2">
                                                  <Tooltip title={"Raportat"} arrow placement="top">
                                                    <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                  </Tooltip>
                                                  <Tooltip title={"Raportat"} arrow placement="top">
                                                    <FaUserEdit className="dark:text-gray-100" />
                                                  </Tooltip>
                                                </div>
                                              ) : (
                                                <div className="flex items-center space-x-2">
                                                  <Tooltip title={"Neraportat"} arrow placement="top">
                                                    <MdClose className="text-red-700 text-xl" />
                                                  </Tooltip>
                                                  <Tooltip title={"Neraportat"} arrow placement="top">
                                                    <FaUserCheck className="dark:text-gray-100" />
                                                  </Tooltip>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </button>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>

                        <h2 className="font-semibold text-gray-700 dark:text-gray-200 xs:hidden">Alte activitati</h2>

                        <table className="w-full">
                          <tbody>
                            {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>
                                      <button
                                        className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700 w-full text-left hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        onClick={() => item.report_detail_id !== null ? setSelecteddeleteuser4(item) : setSelecteddeleteuser1(item)}
                                      >
                                        <div className="grid grid-cols-1 gap-2">
                                          <div className="font-medium">
                                            <span className="text-gray-600 dark:text-gray-300">Activitate: </span>
                                            {item.activity_type}

                                          </div>

                                          <div className="flex items-center justify-between">
                                            <span className="text-gray-600 dark:text-gray-300">Interval orar: </span>
                                            {
                                              item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                  <span>{item.start_time} - {item.end_time}</span>)
                                            }
                                          </div>

                                          <div>
                                            <span className="text-gray-600 dark:text-gray-300">Instituție: </span>
                                            {
                                              item.location?.institution || "Nu exista institutie"
                                            }
                                          </div>

                                          <div>
                                            <span className="text-gray-600 dark:text-gray-300">Adresă: </span>
                                            {
                                              item.location?.address + " - " + item.location?.city || "Nu exista institutie"
                                            }
                                          </div>

                                          <div>
                                            <span className="text-gray-600 dark:text-gray-300">Specialitate: </span>
                                            {item.activity?.speciality || "Nu exista specialitate"}
                                          </div>

                                          <div>
                                            <span className="text-gray-600 dark:text-gray-300">Persoane: </span>
                                            {item.persons}
                                          </div>

                                          <div className="flex justify-end items-center">
                                            <div className="flex gap-1">
                                              {item.report_detail_id !== null ? (
                                                <div className="flex items-center space-x-2">
                                                  <Tooltip title={"Raportat"} arrow placement="top">
                                                    <MdOutlineDoneAll className="text-green-700 text-xl" />
                                                  </Tooltip>
                                                  <Tooltip title={"Raportat"} arrow placement="top">
                                                    <FaUserEdit className="dark:text-gray-100" />
                                                  </Tooltip>
                                                </div>
                                              ) : (
                                                <div className="flex items-center space-x-2">
                                                  <Tooltip title={"Neraportat"} arrow placement="top">
                                                    <MdClose className="text-red-700 text-xl" />
                                                  </Tooltip>
                                                  <Tooltip title={"Neraportat"} arrow placement="top">
                                                    <FaUserCheck className="dark:text-gray-100" />
                                                  </Tooltip>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </button>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </>
                    </div>
                  </div>
                </div>
              </CardContent>
              <Divider className="dark:bg-gray-400" />
              <CardActions sx={{ justifyContent: 'flex-end' }}>
              </CardActions>
            </Card>
          </form>
        </div>
      )}
    </div>
  );
}

export default DashboardCard24viwe;